var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTopRightCorner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 260,
    viewBox: "0 0 125 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 258.5V258.5C66.1694 244.199 113 186.072 113 118.863V12.5",
    stroke: "#4285F4",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 0L123.325 17.7083H101.675L112.5 0Z",
    fill: "#4285F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTopRightCorner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/top_right_corner.23ac4e18187a0d79422aded66528ddb6.svg";